var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8654 8.25706C17.8491 8.16967 17.8287 8.0861 17.796 8.00632C17.8082 7.98732 20.5217 4.47307 18.0085 2.29995C15.4993 0.126825 12.5692 2.96102 12.5528 2.97621C12.0869 2.83944 11.617 2.75585 11.1511 2.71786C11.1511 2.71786 11.1511 2.71786 11.147 2.71786C10.1907 2.56969 8.85034 2.71786 8.85034 2.71786C8.38856 2.75585 7.92269 2.83944 7.46089 2.9724C7.44454 2.95721 4.51444 0.123027 2.00527 2.29615C-0.503916 4.46928 2.2055 7.98732 2.21777 8.00252C2.18917 8.0861 2.16464 8.16967 2.14829 8.25326C1.87858 9.75773 0.0273438 10.2212 0.0273438 12.8427C0.0273438 15.5135 1.96031 17.6182 5.90799 17.6182H7.52628C7.53445 17.6258 8.15971 18.4541 9.45108 18.5034C9.45108 18.5034 9.7494 18.5338 10.4359 18.511C11.805 18.511 12.4711 17.6334 12.4752 17.622H14.0935C18.0411 17.622 19.9741 15.5173 19.9741 12.8465C19.9863 10.2288 18.1351 9.76153 17.8654 8.25706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeraIcon);
export default __webpack_public_path__ + "static/media/BeraIcon.f56e1a3cf5cfa68b1a19b091f74414ce.svg";
export { ForwardRef as ReactComponent };